import type { RouteRecordRaw } from 'vue-router';

export const shipRoutes: Array<RouteRecordRaw> = [
  {
    path: '/ship',
    name: 'ship',
    redirect: '/ship/list',
    component: () => import('pages/micros/shipping/McShip.vue'),
    meta: {
      title: 'Shippings',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'shipList',
        component: () => import('pages/micros/shipping/ShipList.vue'),
        meta: {
          title: 'Shippings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'shipDetail',
        component: () => import('pages/micros/shipping/ShipDetail.vue'),
        meta: {
          title: 'Shipping Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'shipNew',
        component: () => import('pages/micros/shipping/ShipNew.vue'),
        meta: {
          title: 'New Shipping',
          requiresAuth: true,
        },
      },
      {
        path: 'costing',
        name: 'shipCostComputation',
        component: () => import('pages/micros/shipping/ShipCostComputation.vue'),
        meta: {
          title: 'Shipping Cost Computation',
          requiresAuth: true,
        },
      },
      {
        path: 'provider',
        name: 'shipProvider',
        redirect: '/ship/provider/list',
        component: () => import('pages/micros/shipping/provider/ShipProvider.vue'),
        meta: {
          title: 'Shipping Providers',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list/:appId?/:appName?',
            name: 'shipProviderList',
            component: () => import('pages/micros/shipping/provider/ShipProviderList.vue'),
            meta: {
              title: 'Shipping Providers List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'shipProviderDetail',
            component: () => import('pages/micros/shipping/provider/ShipProviderDetail.vue'),
            meta: {
              title: 'Shipping Provider Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'shipProviderNew',
            component: () => import('pages/micros/shipping/provider/ShipProviderNew.vue'),
            meta: {
              title: 'New Shipping Provider',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'cost',
        name: 'shipCost',
        redirect: '/ship/cost/list',
        component: () => import('pages/micros/shipping/cost/ShipCost.vue'),
        meta: {
          title: 'Shipping Costs',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list/:shipSpecId?',
            name: 'shipCostList',
            component: () => import('pages/micros/shipping/cost/ShipCostList.vue'),
            meta: {
              title: 'Shipping Costs List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'shipCostDetail',
            component: () => import('pages/micros/shipping/cost/ShipCostDetail.vue'),
            meta: {
              title: 'Shipping Cost Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'shipCostNew',
            component: () => import('pages/micros/shipping/cost/ShipCostNew.vue'),
            meta: {
              title: 'New Shipping Cost',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'spec',
        name: 'shipSpec',
        redirect: '/ship/spec/list',
        component: () => import('pages/micros/shipping/spec/ShipSpec.vue'),
        meta: {
          title: 'Shipping Specifications',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'shipSpecList',
            component: () => import('pages/micros/shipping/spec/ShipSpecList.vue'),
            meta: {
              title: 'Shipping Specifications List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'shipSpecDetail',
            component: () => import('pages/micros/shipping/spec/ShipSpecDetail.vue'),
            meta: {
              title: 'Shipping Specification Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'shipSpecNew',
            component: () => import('pages/micros/shipping/spec/ShipSpecNew.vue'),
            meta: {
              title: 'New Shipping Specification',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
